import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ApiEnvironmentService } from './api/api-environment.service';
import { ApplicationVersionDto } from '../models/dto/application-version.dto';
import { VersionInfoDto } from '../models/dto/version-info.dto';

@Injectable({ providedIn: 'root' })
export class VersionService {
    private readonly http = inject(HttpClient);
    private readonly apiEnvironment = inject(ApiEnvironmentService);

    private readonly version$ = forkJoin({
        frontend: this.http.get<VersionInfoDto>('assets/version.json').pipe(catchError(() => of(new VersionInfoDto({ version: 'n/d' })))),
        backend: this.apiEnvironment.getVersion().pipe(catchError(() => of(new VersionInfoDto({ version: 'n/d' }))))
    }).pipe(
        map(version => new ApplicationVersionDto(version)),
        shareReplay(1)
    );

    getVersion(): Observable<ApplicationVersionDto> {
        return this.version$;
    }
}
